import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import request from '../../../../../utils/request';
import TypeAhead from '../../../../../orderDetails/components/typeAhead';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByAssignee = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { filterByAssignee, assigneModelHeader }
  } = localizedStrings;
  const [assigneesList, setAssigneesList] = useState();

  useEffect(() => {
    const getAssignees = async () => {
      const result = await request.get('/sovAgentAndAdminUsers');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          id: item.id
        }));
        setAssigneesList(transformedResult);
      }
    };
    getAssignees();
  }, []);

  return (
    <div style={{ margin: '1rem 2rem', gridArea: 'f-asignee' }}>
      <TypeAhead
        label={filterByAssignee}
        placeholder={assigneModelHeader}
        options={assigneesList}
        selected={filters.assignedUserId}
        onChange={value => setFilters({ ...filters, assignedUserId: value })}
      />
    </div>
  );
};

FilterByAssignee.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByAssignee;
